/**
 * A page's search and share metadata: title, description, canonical, Open
 * Graph, Twitter and structured data, from src/content/seo. These are the same
 * tags the pre-renderer writes into the page's static HTML, so both agree.
 *
 *   <PageSeo path="/about" />                    a page in src/content/seo/pages.js
 *   <PageSeo path="/guides/x" jsonLd={[...]} />  the same, plus page-built structured data
 *   <PageSeo meta={meta} />                      metadata built elsewhere (Help, Security)
 */
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { headTags, jsonForScript } from '@/content/seo/site';
import { metaForPath } from '@/content/seo/pages';

export default function PageSeo({ path, meta, jsonLd }) {
  const base = meta || metaForPath(path);
  if (!base) return null;
  const m = jsonLd ? { ...base, jsonLd: [...(base.jsonLd || []), ...jsonLd] } : base;
  return (
    <Helmet>
      <title>{m.title}</title>
      {headTags(m).map(({ tag: Tag, attrs, json }, i) => (
        json !== undefined
          ? <script key={i} {...attrs}>{jsonForScript(json)}</script>
          : <Tag key={i} {...attrs} />
      ))}
    </Helmet>
  );
}
PageSeo.propTypes = { path: PropTypes.string, meta: PropTypes.object, jsonLd: PropTypes.arrayOf(PropTypes.object) };
